export const CURRENT_CONFIG = {

  // license (fahari kenya)
  appId: '194413',
  appKey: 'f114cd6b67c3e5812d87a04ba68c844',
  appLicense: 'HEE/oFjWiD6u74FL8Lv28KMZ3yF08rMtdcnea2cgRCi/drDwjz64l3ZpSB80nMoKW9yI5/wrb4FLdLl1m/3L3C2lpqrtg2COl5n4+oZCFMjedRyOxJP52ofmP+Aj91B2Vz0XRRzDmBwMws9Tzdq7RZ/J1A/40bZeA8eN8OBVf0g=',

  // http — HTTPS via domain + Let's Encrypt through Nginx (Pilot 2 accepts real cert)
  baseURL: 'https://genomemind.servernah.ai/',
  websocketURL: 'wss://genomemind.servernah.ai/api/v1/ws',

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'Please enter the rtmp access address.', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
